import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import {
  getAuthToken,
  getPermissionsFromToken,
  userHasPermission,
} from "../../utils/auth";

const NAV_ITEMS = [
  { label: "Dashboard", path: "/dashboard/home", permissions: ["dashboard"] },
  {
    label: "CMS User Management",
    path: "/dashboard/manageUser",
    permissions: ["cms_roles", "roles"],
  },
  {
    label: "Role Management",
    path: "/dashboard/manageRole",
    permissions: ["cms_roles"],
  },
  {
    label: "Customer Management",
    path: "/dashboard/manageCustomer",
    permissions: ["user", "organization"],
  },
  {
    label: "Arbitration Managment",
    path: "/dashboard/mngArbi",
    permissions: ["commence"],
  },
  {
    label: "Ticket Managment",
    path: "/dashboard/TicketList",
    permissions: ["TICKET"],
  },
  // { label: "Orders", path: "/dashboard/orders", permissions: ["order"] },
  {
    label: "Payment Revenue",
    path: "/dashboard/paymentManage",
    permissions: ["payment"],
  },
  {
    label: "WhatsApp Campaign",
    path: "/dashboard/whatsappCampaign",
    permissions: ["notification_service"],
  },
  {
    label: "Email Campaign",
    path: "/dashboard/EmailCampaign",
    permissions: ["notification_service"],
  },
  // { label: "E-filling", path: "/dashboard/efiling", permissions: ["efiling"] },
];

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const token = getAuthToken();

    if (!token) {
      navigate("/");
      return;
    }

    const perms = getPermissionsFromToken();
    setPermissions(perms);
  }, [navigate]);

  const navItemsWithAccess = useMemo(
    () =>
      NAV_ITEMS.map((item) => ({
        ...item,
        canAccess: userHasPermission(permissions, item.permissions),
      })),
    [permissions]
  );

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <>
      {/* Mobile Hamburger Button */}
      <button
        onClick={toggleMenu}
        className="md:hidden fixed top-20 left-4 z-50 text-white"
      >
        {isMenuOpen ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-7 w-7"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        ) : (
          <GiHamburgerMenu size={28} />
        )}
      </button>

      {/* Sidebar */}
      <div
        className={`fixed top-[100px] left-0 z-40 w-64 h-[calc(100vh-90px)] bg-heading-clr text-white transform transition-transform duration-300 
        ${isMenuOpen ? "translate-x-0" : "-translate-x-full"} 
        md:translate-x-0`}
      >
        <div  className="px-4 pt-6 pb-10 overflow-y-auto h-full">
          <ul className="space-y-2">

            {navItemsWithAccess.map((item) => (
              <li
                key={item.path}
                className={`px-4 py-3 rounded-lg transition ${
                  location.pathname === item.path
                    ? "bg-blue-600"
                    : "hover:bg-gray-700"
                } ${!item.canAccess ? "opacity-50 cursor-not-allowed" : ""}`}
              >
                {item.canAccess ? (
                  <Link
                    to={item.path}
                    onClick={() => setIsMenuOpen(false)}
                    className="block w-full"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span className="block w-full">{item.label}</span>
                )}
              </li>
            ))}

          </ul>
        </div>
      </div>

      {/* Mobile Overlay */}
      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black/40 md:hidden"
          onClick={() => setIsMenuOpen(false)}
        />
      )}
    </>
  );
};

export default Sidebar;